<template>
  <section class="product-step">
    <header>
      <h2>{{step.title}}</h2>
    </header>
    <div class="container text-center">
      <div class="step-image-wrapper">
        <img v-if="isEn" v-lazy="enImage" alt="" draggable="false">
        <img v-else v-lazy="cnImage" alt="" draggable="false">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductStep',
  props: {
    step: Object
  },
  computed: {
    ...mapGetters(['language']),
    isEn () {
      return this.language === 'en'
    },
    enImage () {
      return require('../../../static/images/product/step-en.jpeg')
    },
    cnImage () {
      return require('../../../static/images/product/step-cn.jpeg')
    }
  }
}
</script>

<style lang="scss">
.products > section.product-step,
.products section.product-step {
  padding-top: 100px;
  padding-bottom: 100px;

  > header {
    margin: 0 0 1rem;

    h2 {
      margin: 0;
    }
  }

  .step-image-wrapper {
    width: 100%;
    height: 600px;
    overflow: hidden;
    border-radius: 12px;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  @media (max-width: 768px) {
    padding-top: 0;
    padding-bottom: 0;

    .step-image-wrapper {
      height: 300px;
    }
  }
}
</style>
